<div class="z-spinner-wrap">
  <div [ngClass]="(dataService.showLoadingIndicator$ | async) ? 'z-spinner-show' : ''" class="z-spinner">
    <div class="z-bounce1"></div>
    <div class="z-bounce2"></div>
    <div class="z-bounce3"></div>
  </div>
</div>
